export default __webpack_public_path__ + "static/media/true_tick.7de417b6.svg";